export class DynamicLayoutIdentity {
  layoutId?: string;
  title?: string;
}
